import { discountedPrice } from '@modules/ProductColorPrice/S/fs';

export const campaignLikeCateItem = {
  isCampaign(query) {
    return this.getCampaignId(query);
  },
  getCampaignId(query) {
    const campaign_id = Number(query.campaign_id);
    if (!Number.isNaN(campaign_id)) {
      return campaign_id;
    }
  },
  getPriceInfoForBp(bp) {
    return bp.is_campaign && bp.price_info;
  },
  getDiscountRanges,
};
function getDiscountRanges(quantity, price_info, base_product_size_id) {
  return discountedPrice({ price_info }, quantity, base_product_size_id, undefined, true).discounted_one;
}
